/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkLoxoneStatusDto } from '../models/work-loxone-status-dto';

@Injectable({ providedIn: 'root' })
export class WorkLoxoneV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `loxoneV2ControllerSyncUsers()` */
  static readonly LoxoneV2ControllerSyncUsersPath = '/v2/loxone/sync';

  /**
   * Required permissions: users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loxoneV2ControllerSyncUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  loxoneV2ControllerSyncUsers$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkLoxoneV2Service.LoxoneV2ControllerSyncUsersPath, 'post');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `loxoneV2ControllerSyncUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loxoneV2ControllerSyncUsers(
    params?: {
    },
    context?: HttpContext
  ): Observable<void> {
    return this.loxoneV2ControllerSyncUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `loxoneV2ControllerSyncSingleUser()` */
  static readonly LoxoneV2ControllerSyncSingleUserPath = '/v2/loxone/sync/{userId}';

  /**
   * Required permissions: users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loxoneV2ControllerSyncSingleUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  loxoneV2ControllerSyncSingleUser$Response(
    params: {
      userId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkLoxoneV2Service.LoxoneV2ControllerSyncSingleUserPath, 'post');
    if (params) {
      rb.path('userId', params.userId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `loxoneV2ControllerSyncSingleUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loxoneV2ControllerSyncSingleUser(
    params: {
      userId: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.loxoneV2ControllerSyncSingleUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `loxoneV2ControllerGetStatus()` */
  static readonly LoxoneV2ControllerGetStatusPath = '/v2/loxone/status';

  /**
   * Required permissions: users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loxoneV2ControllerGetStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  loxoneV2ControllerGetStatus$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkLoxoneStatusDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkLoxoneV2Service.LoxoneV2ControllerGetStatusPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkLoxoneStatusDto>;
      })
    );
  }

  /**
   * Required permissions: users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `loxoneV2ControllerGetStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loxoneV2ControllerGetStatus(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkLoxoneStatusDto> {
    return this.loxoneV2ControllerGetStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkLoxoneStatusDto>): WorkLoxoneStatusDto => r.body)
    );
  }

}
